module.exports = __webpack_public_path__ + "static/media/52_tn.45845157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/52_tn.jpg
// module id = 540
// module chunks = 0